<script>
import LandingNav from '@/components/landing/LandingNav.vue'
import HeaderSection from '@/components/landing/HeaderSection.vue'
import HowItWorksSection from '@/components/landing/HowItWorksSection.vue'
import ChatbotExplanationSection from '@/components/landing/ChatbotExplanationSection.vue'

import CycleInformationListSection from '@/components/landing/CycleInformationListSection.vue'
import ConnectNowSection from '@/components/landing/ConnectNowSection.vue'
import AboutYeekoSection from '@/components/landing/AboutYeekoSection.vue'
import ClientsSection from '@/components/landing/ClientsSection.vue'
import FooterSection from '@/components/landing/FooterSection.vue'

export default {
  name: "LandingHolder",
  components: {
    LandingNav,
    HeaderSection,
    HowItWorksSection,
    ChatbotExplanationSection,
    CycleInformationListSection,
    ConnectNowSection,
    AboutYeekoSection,
    ClientsSection,
    FooterSection
  },
  mounted(){
    console.log("Landing")
    this.$store.dispatch("CHECK_AUTH_SIMPLE")
    this.$store.dispatch("LOAD_PLUGIN")
  },
};

</script>

<template>
  <v-app id="app-landing">
    <LandingNav/>
    <v-main>
      <v-container pa-0 fluid>
        <HeaderSection/>
        <HowItWorksSection/>
        <ChatbotExplanationSection/>
        <CycleInformationListSection />
        <ConnectNowSection/>
        <!-- <AboutYeekoSection v-if="false"/> -->
        <ClientsSection/>
        <FooterSection class="text-center"/>
        <div id="whatsapp-button"></div>
        <div id="fb-root"></div>
        <div id="fb-customer-chat" class="fb-customerchat"></div>

      </v-container>
    </v-main>
  </v-app>
</template>

<style lang="scss">
  #app-landing{
    margin: auto;
    max-width: 1040px;
  }
#whatsapp-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
}

#whatsapp-button img {
  width: 30px;
  height: 30px;
}

#whatsapp-dialog {
  position: fixed;
  bottom: 90px;
  right: 20px;
  background-color: #f8f8f8;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
  display: none;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}
</style>